import React from 'react'
import { JsonLdScript } from '../JsonLdScript/JsonLdScript'

type FaqProps = {
    content: string
}

const Faq = ({ content }: FaqProps): JSX.Element | null => {
    const tempElement = document.createElement('DIV')
    tempElement.innerHTML = content

    const data = tempElement.getElementsByClassName('faq-schema-content')
    const schemaData = []
    for (let i = 0; i < data.length; i++) {
        const questionData = data[i].getElementsByClassName(
            'faq-schema-question'
        )
        const answerData = data[i].getElementsByClassName('faq-schema-answer')
        if (questionData.length > 0 || answerData.length > 0) {
            schemaData.push({
                '@type': 'Question',
                name: questionData?.[0]?.textContent || '',
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: answerData?.[0]?.textContent || ''
                }
            })
        }
    }

    const faqData = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: schemaData
    }

    return schemaData.length > 0 ? (
        <JsonLdScript id="faq-json-ld" data={faqData} />
    ) : null
}

export default Faq
